module.exports = __webpack_public_path__ + "img/kapoorp.0606668e.jpg";